import { render, staticRenderFns } from "./MIcon.vue?vue&type=template&id=c924717e&scoped=true"
import script from "./MIcon.vue?vue&type=script&lang=js"
export * from "./MIcon.vue?vue&type=script&lang=js"
import style0 from "./MIcon.vue?vue&type=style&index=0&id=c924717e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c924717e",
  null
  
)

export default component.exports